exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border-class-notice{border:2px solid #757575;height:57px;display:-webkit-box;display:-ms-flexbox;display:flex}.date-picker-notice{font-size:1.2em;display:-webkit-box;display:-ms-flexbox;display:flex}.clock-notice,.date-picker-notice{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}.clock-notice{margin-left:10px}.pickers{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;-webkit-box-align:center;-ms-flex-align:center;align-items:center}", ""]);

// exports
